import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/api-client";
import type { Service } from "@/lib/types";

export function useServices() {
  return useQuery({
    queryKey: ['/services'],
    queryFn: async (): Promise<Service[]> => {
      const res = await apiClient.get('/services');
      if (!res.ok) throw new Error("Failed to fetch services");
      return res.json();
    },
  });
}

export function useService(id: string) {
  return useQuery({
    queryKey: ['/services', id],
    queryFn: async (): Promise<Service | null> => {
      const res = await apiClient.get(`/services/${id}`);
      if (res.status === 404) return null;
      if (!res.ok) throw new Error("Failed to fetch service");
      return res.json();
    },
    enabled: !!id,
  });
}
